module.exports = __webpack_public_path__ + "static/journalism-banner.0d933fd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journalism-banner.jpg
// module id = 475
// module chunks = 263791100135453